import type {
  IconBlockFragment,
  IconBlockGroupFragment,
} from '@seek/cmsu-cms-connect';
import { Box, Stack } from 'braid-design-system';
import React from 'react';
import { Heading, Paragraph } from '..';

import { renderIcon } from './renderer';
import { getBoxBackgroundProps } from '../PageComponent/helper';

type Props = Pick<IconBlockFragment, 'heading' | 'icon' | 'paragraph'> &
  Pick<
    IconBlockGroupFragment,
    'blockBackground' | 'iconAlignment' | 'inlineBlockItem'
  >;

export const IconBlock = ({
  icon,
  heading,
  paragraph,
  blockBackground,
  iconAlignment,
  inlineBlockItem,
}: Props) => (
  <Box
    {...getBoxBackgroundProps(blockBackground)}
    height="full"
    padding="gutter"
    data-testid="IconBlockTestId"
  >
    {inlineBlockItem ? (
      <Box display="flex">
        {Boolean(icon) && (
          <Box
            display="flex"
            alignItems={iconAlignment || 'flexStart'}
            marginRight="gutter"
          >
            {renderIcon(icon)}
          </Box>
        )}
        <Box width="full" justifyContent="flexStart">
          {Boolean(heading) && (
            <Heading {...heading} text={heading?.text || ''} />
          )}
          {paragraph && (
            <Paragraph
              content={paragraph.Paragraph_text?.raw}
              align={paragraph.align}
              tone={paragraph.tone}
              size={paragraph.size}
            />
          )}
        </Box>
      </Box>
    ) : (
      <Stack space="large" align="center">
        {renderIcon(icon)}
        {Boolean(heading) && (
          <Heading {...heading} text={heading?.text || ''} />
        )}
        {paragraph?.Paragraph_text && (
          <Paragraph
            content={paragraph.Paragraph_text.raw}
            align={paragraph.align}
            tone={paragraph.tone}
            size={paragraph.size}
          />
        )}
      </Stack>
    )}
  </Box>
);
